<template>
  <v-container v-if="show" fluid>
    <v-row>
      <h3>
        Dados Gerais do Envelope
      </h3>
      <v-spacer></v-spacer>
      <span>
        <v-btn color="info" v-if="disabledByStatus" dark @click="saveEnvelopeBasicsData">
          Salvar Dados Gerais
        </v-btn>
      </span>
    </v-row>

    <v-dialog v-model="isLoadingEnvelopeData" max-width="320" persistent>
      <v-list class="py-5" color="primary" elevation="12" rounded>
        <v-list-item class="d-flex justify-space-between">
          <div>
            <span style="color: white; font-size: large;">Salvando Alterações...</span>
          </div>
          <div>
            <v-progress-circular color="#1A237E" indeterminate size="32" width="2"></v-progress-circular>
          </div>
        </v-list-item>
      </v-list>
    </v-dialog>

    <v-divider style="margin-top: 10px;"></v-divider>

    <v-row>
      <v-col cols="3">
        <v-text-field
            v-model="mappedStatus"
            :disabled="isLoadingEnvelopeData"
            readonly
            label="Status"
            outlined/>
      </v-col>
      <v-col cols="9">
        <v-text-field
            v-model="envelopeBasicsData.attributes && envelopeBasicsData.attributes.name"
            :disabled="isLoadingEnvelopeData"
            label="Nome do Envelope"
            outlined/>
      </v-col>
    </v-row>

    <v-row class="negative-mt-40">
      <v-col cols="6">
        <v-text-field
            v-model="envelopeBasicsData.attributes && envelopeBasicsData.attributes.default_message"
            :disabled="isLoadingEnvelopeData"
            label="Mensagem Padrão de Notificação"
            outlined/>
      </v-col>
      <v-col cols="6">
        <v-text-field
            v-model="envelopeBasicsData.attributes && envelopeBasicsData.attributes.default_subject"
            :disabled="isLoadingEnvelopeData"
            label="Assunto Padrão do e-mail de Notificação"
            outlined/>
      </v-col>
    </v-row>

    <v-row class="negative-mt-40">
      <v-col cols="3">
        <v-text-field
            v-model="envelopeBasicsData.attributes && envelopeBasicsData.attributes.created"
            :disabled="isLoadingEnvelopeData"
            label="Criado em"
            readonly
            outlined/>
      </v-col>

      <v-col cols="3">
        <v-text-field
            v-model="envelopeBasicsData.attributes && envelopeBasicsData.attributes.modified"
            :disabled="isLoadingEnvelopeData"
            label="Última Movimentação"
            readonly
            outlined/>
      </v-col>

      <v-col cols="3">
        <v-text-field
            v-model="envelopeBasicsData.attributes && envelopeBasicsData.attributes.deadline_at"
            @input="onInputDate"
            @keypress="onKeyPressDate"
            maxLength="19"
            :disabled="isLoadingEnvelopeData"
            label="Prazo Final"
            outlined/>
      </v-col>

      <v-col cols="3">
        <v-select
            outlined
            :disabled="isLoadingEnvelopeData"
            v-model="envelopeBasicsData.attributes && envelopeBasicsData.attributes.remind_interval"
            label="Intervalo de Lembrete"
            :items="intervalReminder"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" class="negative-mt-40">
        <v-checkbox :disabled="isLoadingEnvelopeData" v-model="envelopeBasicsData.attributes && envelopeBasicsData.attributes.auto_close" label="Finalizar Fluxo Automaticamente"></v-checkbox>
      </v-col>
      <v-col cols="6" class="negative-mt-40 negative-ml-40">
        <v-checkbox :disabled="isLoadingEnvelopeData" v-model="envelopeBasicsData.attributes && envelopeBasicsData.attributes.block_after_refusal" label="Pausar Fluxo Após Recusa de Assinatura"></v-checkbox>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import EnvelopeBasicsScript from './EnvelopeBasicsScript';

export default EnvelopeBasicsScript;
</script>

<style scoped>
.negative-mt-40 {
  margin-top: -40px;
}

.negative-ml-40{
  margin-left: -40px;
}
</style>